import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-verification',
  templateUrl: './account-verification.component.html',
  styleUrls: ['./account-verification.component.scss']
})
export class AccountVerificationComponent implements OnInit {
  verificationForm: FormGroup;
  email: string;
  errorMessage: string = ''; // For displaying error messages
  resendCooldown: number = 0; // For cooldown logic
  resendDisabled: boolean = false; // To disable/enable the resend button

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute // Inject ActivatedRoute
  ) { }

  ngOnInit(): void {
    // Initialize the form with an empty email field
    this.verificationForm = this.fb.group({
      email: [{value: '', disabled: true}, [Validators.required, Validators.email]],
      verificationCode: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]], // Assuming a 6-digit code
    });

    // Read the email from the query parameters and set it in the form
    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
      if (this.email) {
        this.verificationForm.patchValue({email: this.email});
      }
    });

    this.checkResendCooldown();
  }



  checkResendCooldown() {
    // Check local storage or any other mechanism you have to keep track of cooldown
    const cooldown = localStorage.getItem('resendCooldown');
    if (cooldown) {
      const cooldownTime = parseInt(cooldown, 10);
      const currentTime = Date.now();
      const difference = (cooldownTime - currentTime) / 1000;

      if (difference > 0) {
        this.startCooldown(difference);
      }
    }
  }


  startCooldown(duration: number) {
    this.resendCooldown = duration;
    this.resendDisabled = true;

    const interval = setInterval(() => {
      this.resendCooldown--;
      if (this.resendCooldown <= 0) {
        clearInterval(interval);
        this.resendDisabled = false;
        localStorage.removeItem('resendCooldown'); // Clear cooldown from storage once finished
      }
    }, 1000);
  }

  resendVerificationEmail() {
    if (!this.email) return;

    this.authService.resendVerificationEmail(this.email).subscribe({
      next: () => {
        console.log('Verification email resent.');
        // Start cooldown
        const cooldownTime = Date.now() + 60000; // 60 seconds from now
        localStorage.setItem('resendCooldown', cooldownTime.toString());
        this.startCooldown(60);
      },
      error: (error) => {
        console.error('Error resending verification email:', error);
        this.errorMessage = 'Error resending verification email. Please try again.';
      }
    });
  }

  onSubmit(): void {
    if (this.verificationForm.invalid) {
      return;
    }

    // Since email field is disabled, manually include it in the form submission value
    const formValue = this.verificationForm.getRawValue();
    formValue.email = this.email;

    this.authService.verifyEmail(formValue.email, formValue.verificationCode).subscribe({
      next: (response) => {
        // Store JWT token in localStorage
        localStorage.setItem('token', response.token);
        // Navigate to a secure page or home page after successful verification
        this.router.navigate(['/']);
      },
      error: (error) => {
        console.error('Verification failed', error);
        this.errorMessage = error.error.message || 'Verification failed. Please try again.';
      }
    });
  }
}
